/**
 * Tablo satırı eylem düğmesi.
 * Düz metin bağlantılar tıklanabilir görünmüyordu; kenarlıklı küçük düğme
 * hem hedef alanını büyütür hem de eylem olduğunu belli eder.
 */
const VARIANTS = {
  default: "text-gray-600 border-gray-300 bg-white hover:bg-gray-50",
  primary: "text-indigo-700 border-indigo-200 bg-indigo-50 hover:bg-indigo-100",
  warning: "text-amber-700 border-amber-200 bg-amber-50 hover:bg-amber-100",
  success: "text-emerald-700 border-emerald-200 bg-emerald-50 hover:bg-emerald-100",
  danger: "text-red-600 border-red-200 bg-red-50 hover:bg-red-100",
};

export default function RowActionButton({
  variant = "default",
  icon: Icon,
  children,
  className = "",
  ...props
}) {
  return (
    <button
      type="button"
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-lg border text-xs font-semibold whitespace-nowrap transition-colors ${VARIANTS[variant] || VARIANTS.default} ${className}`}
      {...props}
    >
      {Icon && <Icon className="w-3 h-3" />}
      {children}
    </button>
  );
}
